import React, { useEffect, useState } from 'react';
import { clientDuplicatesService } from '../../../_services/clientDuplicates.service';
import { formatUndoUntil, refusalCopy, plural } from './duplicateCopy';
import './Duplicates.css';

/**
 * "Merged with Amy Brooks today. 3 bookings and 2 notes moved here. You can
 * undo this until Sun 26 Oct, 3:12pm. [Undo]" in the client panel while a
 * merge is still undoable (mockup screen 3). Renders nothing otherwise, and
 * nothing on an API without the endpoint.
 */
export default function RecentMergeLine({ clientUserId, onUndone }) {
    const [merge, setMerge] = useState(null);
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        let live = true;
        setMerge(null); setMessage('');
        clientDuplicatesService.recentForClient(clientUserId).then((m) => { if (live) setMerge(m); });
        return () => { live = false; };
    }, [clientUserId]);

    if (!merge && !message) return null;

    const undo = async () => {
        if (busy) return;
        setBusy(true);
        try {
            const out = await clientDuplicatesService.undo({ mergeIds: merge.mergeIds });
            const bad = out.results.find((r) => !r.ok);
            if (bad) { setMessage(refusalCopy(bad.code).body); setBusy(false); return; }
            setMerge(null);
            setMessage('Merge undone. The records are back as they were.');
            if (onUndone) onUndone();
        } catch (e) {
            setMessage(refusalCopy(e.code).body);
        }
        setBusy(false);
    };

    if (message && !merge) {
        return <div className="dup-merged-line" role="status"><div className="dup-merged-text">{message}</div></div>;
    }

    const moved = [
        merge.bookingsMoved ? plural(merge.bookingsMoved, 'booking') : null,
        merge.notesMoved ? plural(merge.notesMoved, 'note') : null,
    ].filter(Boolean);
    const until = formatUndoUntil(merge.undoUntil);

    return (
        <div className="dup-merged-line">
            <div className="dup-merged-text">
                Merged with <strong>{merge.mergedWithName}</strong>.
                {moved.length ? ` ${moved.join(' and ')} moved here.` : ''}
                {until ? ` You can undo this until ${until}.` : ''}
                {message ? <> <br />{message}</> : null}
            </div>
            <button type="button" className="cdp-btn-cancel" onClick={undo} disabled={busy} style={{ color: '#29282D', fontWeight: 600 }}>
                {busy ? 'Undoing…' : 'Undo'}
            </button>
        </div>
    );
}
